import React, { useState } from "react";
import TopHeader from "./nav_top.js";
import RangeBasedRisk from "./_49_range_based_risk.js";
import "./styles.css";

const MODULE_NAME = "Research MN";

// Read userId from sessionStorage, fallback to 1 if not set or invalid
const storedId = sessionStorage.getItem("user_id");
const userId = storedId && !isNaN(Number(storedId)) ? Number(storedId) : 1;

const activeDate = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
const initialScreen = "_38_research_pg";

/**
 * _38_research Component
 * This component can be used to display research-related content.
 */
const _38_research = () => {
  const [screen, setScreen] = useState(initialScreen);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <TopHeader 
        userId={userId} 
        screen={screen} 
        refreshKey={refreshKey}
        onNavigate={setScreen}
      />
      <RangeBasedRisk userId={userId} style={{ marginTop: 24 }} />
    </>
  );
};

export default _38_research;